<!-- Direct theme toggle -->
<button
	*ngIf="appearance === 'toggle'; else appearanceDropdown"
	type="button"
	class="appearance-toggle"
	(click)="onThemeToggle()"
	[attr.aria-label]="darkMode === EnumAddonDarkMode.Dark ? 'Switch to light mode' : 'Switch to dark mode'"
	[attr.aria-pressed]="darkMode === EnumAddonDarkMode.Dark"
>
	<ng-fa-icon
		class="fa-icon d-inline-flex"
		[icon]="darkMode === EnumAddonDarkMode.Dark ? 'moon' : 'sun'"
		[size]="EnumNgFaSize.SizeLG"
	></ng-fa-icon>
</button>

<!-- Light / Dark Mode dropdown -->
<ng-template #appearanceDropdown>
<li
	class="nav-item my-auto"
	ngbDropdown
	placement="auto"
	container="body"
	display="dynamic"
>
	<a
		class="nav-link dropdown-toggle position-relative"
		ngbDropdownToggle
		role="button"
		aria-label="Change appearance"
		title="Change appearance"
	>
		<ng-fa-icon
			class="fa-icon align-middle d-inline-flex"
			[icon]="getAppearanceIcon()"
			[size]="EnumNgFaSize.SizeLG"
		></ng-fa-icon>
	</a>
	<div
		ngbDropdownMenu
		class="dropdown-menu dropdown-menu-right appearance-menu"
	>
		<a
			ngbDropdownItem
			class="appearance-option"
			role="button"
			(click)="onSystemThemeChange()"
			[ngClass]="{ active: appearanceMode === SYSTEM_MODE }"
			[attr.aria-current]="appearanceMode === SYSTEM_MODE ? 'true' : null"
		>
			<ng-fa-icon
				class="fa-icon align-middle me-1 d-inline-flex"
				icon="desktop"
			></ng-fa-icon>
			System Mode
		</a>
		<a
			ngbDropdownItem
			class="appearance-option"
			role="button"
			(click)="onThemeChange(EnumAddonDarkMode.Light)"
			[ngClass]="{ active: appearanceMode === EnumAddonDarkMode.Light }"
			[attr.aria-current]="appearanceMode === EnumAddonDarkMode.Light ? 'true' : null"
		>
			<ng-fa-icon
				class="fa-icon align-middle me-1 d-inline-flex"
				icon="sun"
			></ng-fa-icon>
			Light Mode
		</a>
		<a
			ngbDropdownItem
			class="appearance-option"
			role="button"
			(click)="onThemeChange(EnumAddonDarkMode.Dark)"
			[ngClass]="{ active: appearanceMode === EnumAddonDarkMode.Dark }"
			[attr.aria-current]="appearanceMode === EnumAddonDarkMode.Dark ? 'true' : null"
		>
			<ng-fa-icon
				class="fa-icon align-middle me-1 d-inline-flex"
				icon="moon"
			></ng-fa-icon>
			Dark Mode
		</a>
	</div>
</li>
</ng-template>
